import React from 'react';
import Icon from '../../../components/AppIcon';


const PropertyFilters = ({ filters, onFilterChange, propertyCounts }) => {
  const landlordGroups = [
    { id: 'all', label: 'All Landlords', count: propertyCounts?.total },
    { id: 'smith-properties', label: 'Smith Properties Ltd', count: 45 },
    { id: 'jones-estates', label: 'Jones Estates', count: 32 },
    { id: 'brown-investments', label: 'Brown Investments', count: 28 },
    { id: 'wilson-portfolio', label: 'Wilson Portfolio', count: 18 },
    { id: 'individual-landlords', label: 'Individual Landlords', count: 67 }
  ];

  const propertyTypes = [
    { id: 'all', label: 'All Types', count: propertyCounts?.total },
    { id: 'flat', label: 'Flat', count: 78 },
    { id: 'house', label: 'House', count: 65 },
    { id: 'apartment', label: 'Apartment', count: 42 },
    { id: 'studio', label: 'Studio', count: 25 }
  ];

  const statusCategories = [
    { id: 'all', label: 'All Status', count: propertyCounts?.total },
    { id: 'occupied', label: 'Occupied', count: 167, color: 'var(--color-success)' },
    { id: 'vacant', label: 'Vacant', count: 23, color: 'var(--color-warning)' },
    { id: 'maintenance', label: 'Under Maintenance', count: 8, color: 'var(--color-accent)' },
    { id: 'notice', label: 'Notice Period', count: 12, color: 'var(--color-error)' }
  ];

  const geographicalAreas = [
    { id: 'all', label: 'All Areas', count: propertyCounts?.total },
    { id: 'central-london', label: 'Central London', count: 45 },
    { id: 'north-london', label: 'North London', count: 38 },
    { id: 'south-london', label: 'South London', count: 42 },
    { id: 'east-london', label: 'East London', count: 35 },
    { id: 'west-london', label: 'West London', count: 50 }
  ];

  const handleFilterClick = (category, id) => {
    onFilterChange(category, id);
  };

  const renderFilterSection = (title, items, category, icon) => (
    <div className="mb-6">
      <div className="flex items-center gap-2 mb-3">
        <Icon name={icon} size={16} color="var(--color-accent)" />
        <h3 className="text-sm font-semibold text-foreground font-heading">{title}</h3>
      </div>
      <div className="space-y-1">
        {items?.map((item) => (
          <button
            key={item?.id}
            onClick={() => handleFilterClick(category, item?.id)}
            className={`w-full flex items-center justify-between px-3 py-2 rounded-lg transition-smooth text-left ${
              filters?.[category] === item?.id
                ? 'bg-accent/10 border border-accent' :'bg-input border border-border hover:bg-muted'
            }`}
          >
            <span className={`text-sm font-caption ${
              filters?.[category] === item?.id ? 'text-accent font-medium' : 'text-foreground'
            }`}>
              {item?.label}
            </span>
            <span className={`text-xs font-data ${
              filters?.[category] === item?.id ? 'text-accent' : 'text-muted-foreground'
            }`}>
              {item?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="h-full overflow-y-auto px-4 py-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-foreground mb-2 font-heading">Filters</h2>
        <p className="text-xs text-muted-foreground font-caption">Refine your property search</p>
      </div>

      {renderFilterSection('Landlord Groups', landlordGroups, 'landlord', 'Users')}
      {renderFilterSection('Property Types', propertyTypes, 'type', 'Building2')}
      {renderFilterSection('Status Categories', statusCategories, 'status', 'Activity')}
      {renderFilterSection('Geographical Areas', geographicalAreas, 'area', 'MapPin')}

      <div className="pt-4 border-t border-border">
        <button
          onClick={() => onFilterChange('reset', null)}
          className="w-full px-4 py-2 rounded-lg bg-input border border-border text-sm font-medium text-muted-foreground transition-smooth hover:bg-muted hover:text-foreground font-caption"
        >
          Reset All Filters
        </button>
      </div>
    </div>
  );
};

export default PropertyFilters;